import PropTypes from "prop-types";
import React from "react";

/***
 * Dots component
 * @param slides
 * @param activeSlide
 * @param onClick
 * @returns {JSX.Element}
 * @constructor
 */
export const Dots = ({ children, activeSlide, onClick, locale }) => {
  return (
    <div className="carousel__dots">
      {React.Children.map(children, (child, index) => {
        return (
          <button
            data-testid={`dot-${index}`}
            key={`dot-${index}`}
            className={`carousel__dot ${activeSlide === index ? "active" : ""}`}
            onClick={() => onClick(index)}
          >
            {index + 1}
          </button>
        );
      })}
    </div>
  );
};

Dots.propTypes = {
  children: PropTypes.node,
  activeSlide: PropTypes.number,
  onClick: PropTypes.func,
  locale: PropTypes.string.isRequired,
};
